<template>
  <div class="delete-account containerg">
    <div v-if="isAuthenticated">
      <h1>Ștergere cont</h1>

      <p>
        Această acțiune este <strong>ireversibilă</strong>. Dacă alegi să-ți ștergi contul:
      </p>
      <ul>
        <li>Toate datele asociate contului tău vor fi eliminate definitiv din platformă.</li>
        <li>Nu vei mai putea accesa istoricul comenzilor sau alte informații personale.</li>
        <li>Nu te vei mai putea autentifica folosind acest cont.</li>
      </ul>

      <p style="margin-top: 20px;">
        Dacă ești sigur că vrei să continui, apasă pe butonul de mai jos:
      </p>

      <button @click="deleteAccount" class="danger-button">Șterge definitiv contul</button>
    </div>
    <div v-else>
      <h1>Autentificare necesară</h1>
      <p>Trebuie să fii autentificat pentru a putea accesa această pagină.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DeleteAccount',
  methods: {
    async logout() {
      this.produse_favorite_state = [];
      localStorage.removeItem('token');
      this.$store.commit('seteazaProduseFavorite', []);
      this.cod_tara = "";
      this.telefon_comanda = "";
      this.telefon_comanda_nefinalizat = "";
      this.cod_tara_nefinalizat = "";
      this.form_register = {
        email: "",
        password: ""
      };
      await this.$store.dispatch("LogOut");
    },
    deleteAccount() {
      if (confirm('Ești sigur că vrei să-ți ștergi contul?')) {
        axios.post('https://xpanel.tikibistro.ro/api/profile_delete', {}, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Authorization": `Bearer ${localStorage.token}`,
          },
          withCredentials: false,
        }).then(async (succes) => {
          alert('Contul a fost șters cu succes');
          await this.logout();
          this.$router.push('/');
        }).catch(error => {
          alert('A apărut o eroare la ștergerea contului');
          var json = JSON.stringify(error);
          var actiune = 'https://xpanel.tikibistro.ro/api/profile_delete';
          this.trimiteLog(actiune, json); 
        });
      }
    }
  },
  computed: {
    isAuthenticated() {
      return !!localStorage.getItem('token');
    }
  }
}
</script>

<style scoped>
.delete-account {
  color: white;
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
  margin-top:150px;
}

.delete-account h1 {
  margin-bottom: 20px;
}

.delete-account ul {
  padding-left: 20px;
}

.danger-button {
  background-color: #d9534f;
  color: white;
  border: none;
  padding: 10px 20px;
  margin-top: 20px;
  cursor: pointer;
  border-radius: 4px;
}

.danger-button:hover {
  background-color: #c9302c;
}
</style>